import { render, staticRenderFns } from "./salesforce.vue?vue&type=template&id=f25936fa&"
import script from "./salesforce.vue?vue&type=script&lang=js&"
export * from "./salesforce.vue?vue&type=script&lang=js&"
import style0 from "./salesforce.vue?vue&type=style&index=0&id=f25936fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports